import {Component, Input} from '@angular/core';
export interface PropertyInfo {
    propertyName: string;
    propertyAddress: string;
    zoneName: string;
    cityName: string;
    segmentLabel: string;
    segmentImagePath: string;
    adLabel: string;
    adPrice: string;
    optUseStatus: string;
}
@Component({
  selector: 'app-property-info',
  templateUrl: './property-info.component.html',
  styleUrls: ['./property-info.component.scss']
})
export class PropertyInfoComponent {
    @Input() info!: PropertyInfo;

}
